import React from 'react'
import Link from 'next/link'

import { containerClassName } from '@/components/Container'
import { Button } from '@/components/ui/button'
import type { Locale } from '@/lib/i18n/config'
import { getMessages } from '@/lib/i18n/messages'
import { cn } from '@/utilities/ui'

import { PartnerLogosMarquee } from './PartnerLogosMarquee'

type PartnersCarouselSectionProps = {
  className?: string
  learnMoreHref?: string
  learnMoreLabel?: string
  locale: Locale
}

export function PartnersCarouselSection({
  className,
  learnMoreHref,
  learnMoreLabel,
  locale,
}: PartnersCarouselSectionProps) {
  const copy = getMessages(locale).partners.carousel

  return (
    <section
      aria-labelledby="partners-carousel-heading"
      className={cn('w-full bg-cream', className)}
    >
      <div className="w-full max-w-none">
        <PartnerLogosMarquee
          ariaLabel={copy.ariaLabel}
          heading={copy.headline}
          headingId="partners-carousel-heading"
          partners={copy.partners}
          pauseLabel={copy.pauseLabel}
          playLabel={copy.playLabel}
        />
      </div>

      <div
        className={cn(
          containerClassName,
          'mt-10 px-4 pb-10 pt-0 text-center lg:pb-10 lg:pt-0',
        )}
      >
        <p className="font-outfit text-sm leading-5 text-dark-800/80">{copy.body}</p>
        {learnMoreHref && learnMoreLabel ? (
          <div className="mt-6 flex justify-center">
            <Button
              asChild
              className="rounded-[10px] border-[1.5px] border-dark-300 bg-white/30"
              variant="outline"
            >
              <Link href={learnMoreHref}>{learnMoreLabel}</Link>
            </Button>
          </div>
        ) : null}
      </div>
    </section>
  )
}
